import { Component, h, State, Prop, EventEmitter, Event } from '@stencil/core';
import { Prehomeobj, Countryobj } from '../../model/index';


@Component({
  tag: 'sg-prehome',
  shadow: false
})
export class Prehome {

  @Prop() origin: string;
  @Prop() country: string;
  @Prop() textsMap: Map<string, any>;
  @Prop() showhome: boolean;

  @State() prehome: Array<Prehomeobj>;
  @State() countryObj: Countryobj;
  @State() typeSelected: string;

  @Event({
    eventName: "selectedPoll",
    bubbles: false,
  }) selectedPoll: EventEmitter<string>;
  @Event({
    eventName: "showPollHome",
    bubbles: false,
  }) showPollHome: EventEmitter<boolean>;

  async componentWillLoad() {
    // Configurar los encabezados de la solicitud
    const headers = new Headers();
    headers.append('Authorization', `Basic ${process.env.SERVICES_TOKEN}`);
    headers.append('Content-Type', 'application/json');

    const requestOptions = {
      method: 'GET',
      headers: headers
    };

    try {
      const responsePrehome = await fetch(`${process.env.SERVICES_API}/prehome/${this.country}/${this.origin}`, requestOptions);
      if (!responsePrehome.ok) {
        throw new Error('La solicitud no se completó correctamente');
      }
      this.prehome = await responsePrehome.json();
      console.log("responde prehome");

      const responseHome = await fetch(`${process.env.SERVICES_API}/country/${this.country}`, requestOptions);
      this.countryObj = await responseHome.json();

    } catch (error) {
      console.error('Ocurrió un error:', error);
    }
  }

  clickChooseType(type: string) {
    this.typeSelected = type;
    console.log("clik showhome: " + this.typeSelected);
  }

  clickPrehome() {
    console.log("enviar showhome: " + this.showhome);
    if (this.typeSelected !== undefined) {
      this.showPollHome.emit(this.showhome)
      this.selectedPoll.emit(this.typeSelected);
    }
  }

  render() {
    if (this.prehome.length > 0) {
      return (
        <div class="html">

          <div class="Grid">
            <div class="Grid-cell">
              <div class="Grid">
                <div class="Grid-cell u-md-padSides1 u-padEnds4 u-sm-padSides1">
                <h1 class="font-canela u-textCenter u-textSize5 u-spacebottom6">{this.countryObj.titleprehome}</h1>
                  <p class="u-textCenter">{this.countryObj.descriptionshortprehome} {this.countryObj.descriptionprehome}</p>
                </div>
              </div>
            </div>

            <div class="Grid-cell u-padTop2 u-padBottom6">
              <div class="Grid Grid--alignCenter">
                <div class="Grid-cell u-md-size1of2 u-lg-size1of2 u-sm-padSides1">
                  <div class="Grid Grid--equalHeight font-agnext-medium">
                  {this.prehome.map((prehome) =>
                      <div class="Grid-cell u-sizeFull u-textCenter u-spaceBottom01" >
                        <div class="Grid-cell u-sizeFull u-textCenter u-bgWhite ButtonRounded">
                          <label class="containerHome u-pad01" >
                            <input type="radio" class={this.typeSelected == prehome.type ? 'answer-checked' : ''} name={`polltype_${prehome.type}`} onClick={() => this.clickChooseType(prehome.type)}
                              id={`id_${prehome.type}`}></input>
                            <img src={prehome.preimage}></img>
                            <p class="u-textSize02 u-padLeft2"><strong>{this.textsMap.get(prehome.pretitle)}</strong></p>
                          </label>
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>

            </div>

            <div class="Grid-cell u-sizeFull">
              <div class="Grid">
                <div class="Grid-cell u-md-padSides1 u-padTop2 u-padBottom6 u-textCenter">
                  <button class={this.typeSelected === undefined ? 'ButtonMain button-disabled' : 'ButtonMain'} disabled={this.typeSelected === undefined} onClick={() => this.clickPrehome()}>
                    {this.textsMap.get('button_do_test')} </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      )
    } else {

      return (
        <sg-pagenot></sg-pagenot>
      );
    }
  }
}
